module.exports = __webpack_public_path__ + "img/79.2060e3df.svg";